import { useState, useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import _ from 'lodash';
import { RadioGroup, FormControlLabel, Radio, ButtonBase } from '@material-ui/core';
import { i18n } from '../../../../language';
import { dutyAssignAPI } from '../../../../apis';
import Header from './head';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    margin: '0',
    padding: '0 1.25rem',
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '0.0625rem solid #e4e7eb',
    height: '3.75rem',
    '& .MuiTypography-body1': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1.125rem',
      lineHeight: '1.625rem',
      color: theme.palette.font.main,
      fontWeight: '500',
    },
  },
  radio: {
    fontSize: '1.5rem',
    color: '#e4e7eb',
  },
  foot: {
    padding: '0.938rem 0 0 3.438rem',
    marginBottom: '0.875rem',
    borderTop: '0.0625rem solid #e4e7eb',
  },
  ConfirmBtn: {
    width: '12.5rem',
    height: '3rem',
    borderRadius: '0.625rem',
    backgroundColor: '#4c93ff',
    justifyContent: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    color: theme.palette.font.white,
    fontWeight: '500',
  },
}));

export default function Group({ backOnclick, setGroup, setopen, setgroupopen }) {
  const classes = useStyles();
  const [groupList, setGroupList] = useState([]);
  const [value, setValue] = useState();

  useEffect(() => {
    (async () => {
      await getGroupListAPI();
    })();
  }, []);

  // get group list API
  const getGroupListAPI = async () => {
    try {
      const dutyDateInfo = JSON.parse(sessionStorage.getItem('dutyInfo'));
      const params = {
        timeStart: moment(dutyDateInfo.date).format('YYYY-MM-DD'),
        timeEnd: moment(dutyDateInfo.date).format('YYYY-MM-DD'),
      };
      const { result } = await dutyAssignAPI.getGroupList(params);
      setGroupList(result);
    } catch (error) {
      console.log('-----Get SrsWard error----->', error);
    }
  };

  const groupData = useMemo(() => {
    let list = [];

    if (Array.isArray(groupList) && groupList.length > 0) {
      list = _.map(groupList, (item) => {
        return item;
      });

      setValue(list[0]);
    }

    return list;
  }, [groupList]);

  const handleOnChange = (event) => {
    setValue(event.target.value);
  };

  const handleConfirm = () => {
    setGroup(value);
    setopen(true);
    setgroupopen(false);
  };

  return (
    <div className={classes.root}>
      <div>
        <Header backOnclick={backOnclick} id="DutyAssign-Header-abw" title={i18n.t('DUTYASSIGN_ROSTER_FILTER_GROUP')} />
        {groupData.length > 0 && (
          <RadioGroup
            className={classes.body}
            row
            aria-label="position"
            name="position"
            onChange={handleOnChange}
            id="DutyAssign-RadioGroup-abx"
            defaultValue={groupData[0]}
          >
            {groupData.map((item, index) => (
              <FormControlLabel
                className={classes.label}
                value={item}
                control={<Radio className={classes.radio} color="primary" id={`DutyAssign-RadioGroup-abx-${index}`} />}
                label={item}
                labelPlacement="start"
                key={item}
              />
            ))}
          </RadioGroup>
        )}
      </div>
      {groupData.length > 0 && (
        <div className={classes.foot}>
          <ButtonBase className={classes.ConfirmBtn} onClick={handleConfirm} id="DutyAssign-ButtonBase-aby">
            {i18n.t('DUTYASSIGN_ROSTER_FILTER_GROUP_CONFIRM')}
          </ButtonBase>
        </div>
      )}
    </div>
  );
}
